import { createSelector } from 'reselect';

import { RootState } from '../../reducers';
import { IngredientDryMatters } from './appIngredients.types';

export const getIngredientsDryMatters = (state: RootState) => state.application.ingredients.dryMatters;

export const getIngredientDryMattersById = createSelector(
  [getIngredientsDryMatters],
  (dryMattersList: IngredientDryMatters[]) => (ingredientId: string) => {
    const dryMattersItem = dryMattersList.find((dryMatter) => dryMatter.ingredientId === ingredientId);
    return dryMattersItem && dryMattersItem.dryMatters;
  },
);
